<div
  class="box-old-version"
  *ngIf="showOldVersion"
>
  <div class="old-version-box-notification">
    کاربر گرامی، به دلیل قدیمی بودن نسخه اندروید دستگاه شما، لطفا جهت نمایش و
    خرید محصولات، از وبسایت نوار استفاده نمایید.
  </div>
  <div
    class="old-version-button"
    (click)="goToWeb()"
  >
    <navaar-button
      [type-button]="'button'"
      [color-name]="'yellow-icon'"
    >
      <span class="text-more">ورود به وبسایت نوار</span>
      <navaar-chevron-icon class="list-more"></navaar-chevron-icon>
    </navaar-button>
  </div>
</div>
<div
  class="shop"
  *ngIf="!showOldVersion"
>
  <navaar-header [show-custom-content]="true">
        <span class="box-logo" style="height: auto">
           <ng-container [ngSwitch]="parametersService.clientId">
             <ng-container *ngSwitchCase="clientTypeEnum.Zarebin">
                <navaar-zarebin-logo style="display: inline-block;width: 55px;margin-left: 8px;"></navaar-zarebin-logo>
             </ng-container>
               <ng-container *ngSwitchCase="clientTypeEnum.iGap">
                <navaar-iGap-logo style="display: inline-block;width: 55px;margin-left: 8px;"></navaar-iGap-logo>
             </ng-container>
              <ng-container *ngSwitchCase="clientTypeEnum.iranpl">
                <navaar-iran-pl-icon style="display: inline-block;width: 25px;margin-left: 8px;"></navaar-iran-pl-icon>
             </ng-container>
             <ng-container *ngSwitchCase="clientTypeEnum.ghesse">
                <navaar-ghesse-icon style="display: inline-block;width: 60px;margin-left: 8px;"></navaar-ghesse-icon>
             </ng-container>
             <ng-container *ngSwitchDefault>
                <navaar-logo-icon></navaar-logo-icon>
             </ng-container>
           </ng-container>
        </span>
    <div id="search-container"
         class="truncate"
         [routerLink]="['/search']"
         (click)="indicator.show()">
      <navaar-search-icon style="display: inline-block; width: 17px"></navaar-search-icon>
      <span>جست‌وجو در میان کتاب‌ها، نویسندگان، گویندگان و...</span>
    </div>
  </navaar-header>
  <section
    Pagination
    (goTo)="goToPage($event)"
    [isEnd]="isEnd"
    [disable-when-fetch-data]="isLoading"
    [class.ios-header]="device.isIOS()"
  >
    <div
      class="container"
      id="container-shop"
    >
      <ng-template [ngIf]="shop.length">
        <ng-template
          ngFor
          [ngForOf]="shop"
          let-item
          let-i="index"
        >
          <navaar-banner
            *ngIf="item.sliderInfo"
            [items]="item.sliderInfo.slides"
            [type-banner]="'banner-slider'"
            [type-slider]="item.sliderInfo?.sliderType"
            [event-tracker-name]="eventTrackerName"
          ></navaar-banner>
          <ng-template [ngIf]="i == 1">
            <div class="box-shop-category">
              <div class="box-shop-category-wrapper">
                <ng-template ngFor [ngForOf]="categoryShop" let-category>
                  <div
                    class="truncate bg-{{productType[category.contentType]}}"
                    [routerLink]="['./clp', category.id]"
                    [queryParams]="{title: category.name,contentType: productType[category.contentType]}"
                    (click)="[indicator.show(), trackerEvents({
                                                                    item_name: 'x_icon_clp_shop',
                                                                    x_item_name: category.name
                                                                })]"
                  >
                    <!-- <ng-container [ngSwitch]="category.id">
                        <ng-template [ngSwitchCase]="genre.book">
                            <navaar-book-icon [raw-icon]="true"></navaar-book-icon>
                        </ng-template>
                        <ng-template [ngSwitchCase]="genre.bookSummary">
                            <navaar-book-summary-icon [raw-icon]="true"></navaar-book-summary-icon>
                        </ng-template>
                        <ng-template [ngSwitchCase]="genre.serial">
                            <navaar-serial-icon [raw-icon]="true"></navaar-serial-icon>
                        </ng-template>
                        <ng-template [ngSwitchCase]="genre.podcast">
                            <navaar-podcast-icon [raw-icon]="true"></navaar-podcast-icon>
                        </ng-template>
                    </ng-container> -->
                    <span
                      class="item-circle-name"
                      [textContent]="category.name"
                    ></span>
                  </div>
                </ng-template>
              </div>
            </div>
          </ng-template>
          <div
            class="bg-dark"
            *ngIf="false"
          >
            <navaar-carousel
              *ngIf="item.listInfo"
              [title]="'درحال شنیدن'"
              [type-url]="item.listInfo.title"
              [typeOfCarousel]="carouselType.image_Only"
              [items]="item.listInfo"
              [style-show-all]="'yellow'"
              [type-url]="item.listInfo.apiUrl"
              [index-carousel]="i"
              [name-tracker-event]="'x_shop_list_item'"
            ></navaar-carousel>
          </div>
          <navaar-banner
            *ngIf="item.bannerInfo"
            [items]="item.bannerInfo"
            [type-banner]="'banner'"
            [event-tracker-name]="'x_shop_banner'"
            [index-banner]="i"
          ></navaar-banner>
          <navaar-carousel
            *ngIf="item.listInfo"
            [title]="item.listInfo.title"
            [typeOfCarousel]="item.listInfo.listMode"
            [items]="item.listInfo"
            [badge-type]="item.listInfo.badgeId"
            [type-url]="item.listInfo.apiUrl"
            [style-show-all]="'yellow'"
            [show-rate]="true"
            [index-carousel]="i"
            [name-tracker-event]="'x_shop_list_item'"
          ></navaar-carousel>
        </ng-template>
      </ng-template>
    </div>
  </section>
</div>
